import Notification from './useNotification';
import useScroll from './useScroll';
import useClickOutSide from './useClickOutSide';
import useExternalJS from './useExternalJS';
import useMountComponent from './useMountComponent';

export default {
  useMountComponent,
  useExternalJS,
  useClickOutSide,
  Notification,
  useScroll,
};
